import React, { useEffect, useState, useCallback, useMemo } from "react";
import { connect } from "react-redux";

import GameCard from "./GameCard";
import Spinner from "../ui/spinner/Spinner";
import SetHomePageButton from "../common/SetHomePageButton";

import translate from "../../i18n/translate";
import { getGamingCards } from "../../actions/gameAction";
import { refreshColumnStyle } from "./reusableFunctions";

// Static game data moved outside component
const JWAKER_GAME_DATA = {
  id: "jwaker",
  company_name: "Jawaker",
  url: "https://images.celltop.vip/cards/jawaker.png",
  denominations_db_name: "jwaker",
  mintroute_brand_id: "jwakerBrandId123",
};

const Gaming = ({ getGamingCards, gamesArray, loading, isDarktheme }) => {
  const [columnStyle, setColumnStyle] = useState(
    "col-lg-3 col-md-4 col-sm-6 card-md"
  );

  // Memoize the refresh function call
  const initializeColumnStyle = useCallback(() => {
    refreshColumnStyle(setColumnStyle);
  }, []);

  // Initial setup
  useEffect(() => {
    document.title = "Gaming | Phone Play";
    initializeColumnStyle();
    getGamingCards();
  }, [initializeColumnStyle, getGamingCards]);

  // Memoize the combined games array
  const allGames = useMemo(() => {
    if (!gamesArray || !Array.isArray(gamesArray)) {
      return [JWAKER_GAME_DATA];
    }
    return [...gamesArray, JWAKER_GAME_DATA];
  }, [gamesArray]);

  return (
    <div>
      <div className="card card-home mb-4">
        <div className={!isDarktheme ? "card p-4" : "dark-card p-4"}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <h1 className="header-text">{translate("Gaming")}</h1>
            <SetHomePageButton 
              currentPath="/gaming"
              pageName="Gaming"
              variant="icon"
            />
          </div>
        </div>
      </div>
      
      <div className="row">
        {allGames.map((game) => (
          <GameCard key={game.id} game={game} columnStyle={columnStyle} />
        ))}
      </div>
      
      {loading && (!gamesArray || gamesArray.length === 0) && <Spinner />}
    </div>
  );
};

const mapStateToProps = ({
  games: { gamesArray, loading },
  darkTheme: { isDarktheme },
}) => ({
  gamesArray,
  loading,
  isDarktheme,
});

export default connect(mapStateToProps, { getGamingCards })(Gaming);

